module.exports = __webpack_public_path__ + "static/media/map-gps-arrow-brand-refresh.fc2f1a59.svg";